enum InfoExtractionDialogFields {
	FILE_FORMAT = 'fileFormat'
}

export default InfoExtractionDialogFields;